<template>
  <div>
    <van-field v-model="selectValue" :placeholder="placeholder" type="text" :label="label" :is-link="isLink"
      :disabled='disabled' :readonly="readonly" @focus="onFocus"  :required="required"  :rules="[{ required: required, message: label+'不可为空' }]"/>
    <div class="van-hairline--bottom"></div>
    <van-action-sheet v-model="show" name="abc" :title="title" class="action-sheet-box">
      <!-- 搜索区域 -->
      <van-search v-model="search" placeholder="请输入关键词" @input="OnInput"></van-search>
      <van-cell v-for="(item,index) in dataList.filter(obj=>obj.employerName.indexOf(search)!=-1)" :key="index"
        :title="item.employerName" :is-link="isLink" @click="onSelect(item)">
      </van-cell>
    </van-action-sheet>
  </div>
</template>

<script>
  export default {
    name: 'EmployerSelect',
    props: {
      label: {
        type: String,
        default: '未定义'
      },
      placeholder: {
        type: String,
        default: '请选择'
      },
      title: {
        type: String,
        default: '请选择'
      },
      dictid: {},
      value: {
        default: ''
      },
      disabled: {
        type: Boolean
      },
      isLink: {

      },
      selectkey: {
        default: "",
      },
      // 是否必填
      required: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        form: {
          token: ''
        },
        search: "",
        selectValue: this.value,
        // isLink: false,
        readonly: true,
        show: false,
        dataList: [],
        token: '',
        companyid: ''
      }
    },
    watch: {
      selectkey(newVal) {
        let that = this
        let filterList = that.dataList.filter(m => m.guid == newVal)
        if (filterList.length > 0) {
          that.selectValue = filterList[0].employerName
        }
      }
    },
    methods: {
      onFocus: function() {
        this.show = true
      },
      //搜索框变化事件
      OnInput: function() {
        //this.LoadItem()
      },
      onSelect: function(item) {
        // 默认情况下点击选项时不会自动收起
        // 可以通过 close-on-click-action 属性开启自动收起
        this.show = false
        this.selectValue = item.employerName
        this.$emit('input', this.selectValue)
        this.$emit('update:selectkey', item.guid)
        this.$emit('update:secondkey', "")
      },
      LoadDictItem: function() {
        let args = {
          currentPage: 1,
          pageSize: 9999,
          menuid: this.$utils.MenuEnum.employer
        }
        var that = this
        that.$utils.HttpPost(this.$utils.Url.system + '/api/APISEMP_Employer/AllList', args, function(data) {
         that.dataList=[]
          data.data.forEach((item)=>{
			  for(var key in item){
				item[that.$utils.toLowerCaseFirst(key)]=item[key]
			  }
			  
			  that.dataList.push(item)
		  })
          if (that.selectkey) {
            let filterList = that.dataList.filter(m => m.guid == that.selectkey)
            if (filterList.length > 0) {
              that.selectValue = filterList[0].employerName
            }
          }
        }, null, null)
      }
    },
    mounted: function() {
      this.LoadDictItem()
    }
  }
</script>

<style>
</style>
